"use client";

import * as React from "react";
import { toast as sonnerToast } from "sonner";

import { GlassToastCard } from "@/app/_components/ui/glass-toast";

interface Toast {
  title?: React.ReactNode;
  description?: React.ReactNode;
  variant?: "default" | "destructive";
  duration?: number;
}

function toast({ title, description, variant = "default", duration }: Toast) {
  const id = sonnerToast.custom(
    (toastId) => (
      <GlassToastCard
        id={toastId}
        title={title}
        description={description}
        variant={variant}
      />
    ),
    { duration: duration ?? 4000 },
  );

  return {
    id,
    dismiss: () => sonnerToast.dismiss(id),
  };
}

export { toast };
